module.exports = __webpack_public_path__ + "img/13.9e0ac6af.svg";